import { YoutubeSVG } from '@/Component/Common/SVGs/AuthSVG';
import { FacebookSVG, GoogleSVG, InstagramSVG, TiktokSVG } from '@/Component/Common/SVGs/CommonSVG';
import { formatNumberWithCommas } from '@/Utils/Other/FormatNumberWithCommas';
import { translateJobRequirements } from '@/Utils/Other/TranslateJobRequirement';
import moment from 'moment';
import React from 'react'

const CampaignOverviewInfluencer = (props) => {
    const { data, translations } = props;
    const availableIcons = {
        facebook: <FacebookSVG customClass="w-8 h-8" />,
        instagram: <InstagramSVG customClass="w-8 h-8" />,
        youtube: <YoutubeSVG customClass="w-8 h-8" />,
        tiktok: <TiktokSVG customClass="w-8 h-8" />
    };

    const getApplicantRangeLabel = (applied) => {
        const count = applied ?? 0;
        if (count === 0) return 'Be the first to apply';
        if (count < 10) return '< 10';
        if (count < 25) return '10 - 25';
        if (count < 50) return '25 - 50';
        if (count < 100) return '50 - 100';
        return '100+';
    };

    const dangerousTags = [
        'script',
        'style',
        'iframe',
        'embed',
        'object',
        'img',
        'video',
        'audio',
        'source',
        'link'
    ];

    const sanitizeHtml = (html) => {
        if (!html) return '';
        let result = html;
        dangerousTags.forEach(tag => {
            result = result.replace(new RegExp(`<${tag}[\\s\\S]*?>[\\s\\S]*?<\\/${tag}>`, 'gi'), '');
            result = result.replace(new RegExp(`<${tag}[^>]*?\\/?>`, 'gi'), '');
        });
        return result;
    };

    const formatHtml = (text) => {
        let sanitized = sanitizeHtml(text);
        // Convert URLs to clickable anchor tags
        const urlRegex = /(https?:\/\/[^\s]+)/g;
        const formattedText = sanitized?.replace(urlRegex, (url) => `<a href="${url}" target="_blank" rel="noopener noreferrer" class="text-blue-600 underline">${url}</a>`)?.replace(/\n/g, "<br/>"); // Preserve line breaks

        return formattedText;
    };

    return (
        <div className='border border-lightGray rounded-2xl'>
            <div className='bg-primary/10 rounded-tr-2xl rounded-tl-2xl md:px-6 px-4 md:py-5 py-3 relative'>
                <div className='flex items-center justify-between'>
                    <div className='flex flex-col'>
                        <span className='md:text-base text-sm font-medium'>{moment(data?.posting_start_date).format('DD MMM YYYY')} - {moment(data?.posting_end_date).format('DD MMM YYYY')}</span>
                        <h2 className='md:text-2xl text-xl font-semibold md:mt-4 mt-2 mb-1.5'>{data?.campaign_name}</h2>
                        <div className='inline-block'>
                            <span>{translateJobRequirements(data?.job_requirement, translations)}</span>
                            {/* {data?.content_type?.length > 0 && <span className="rounded-full overflow-hidden text-gray min-w-1 h-1 bg-gray mx-1.5 inline-block align-middle"></span>}
                            <span>{Array.isArray(data?.content_type) ? data?.content_type.join(', ') : data?.content_type}</span> */}
                        </div>
                    </div>
                </div>
            </div>
            <div className='md:px-6 px-4 md:py-5 py-3'>
                <span className='text-xl font-bold mb-3 block'>{translations?.campaignDescription}</span>
                <p className='text-sm' dangerouslySetInnerHTML={{ __html: formatHtml(data?.campaign_requirements) }}></p>

                <div className='flex items-center lg:gap-8 gap-4 mt-7'>
                    {data?.budget_per_influencer > 0 &&
                        <div className='flex flex-col'>
                            <span className='font-semibold text-base'>${formatNumberWithCommas(data?.budget_per_influencer)} {data?.currency} </span>
                            <span className='font-medium text-xs'><span role="img" aria-label="cash" className="mr-1">💰</span>{translations?.cash}</span>
                        </div>
                    }
                    {data?.product_value > 0 && <div className='flex flex-col'>
                        <span className='font-semibold'>${formatNumberWithCommas(data?.product_value)} {data?.currency}</span>
                        <span className='font-medium text-xs'><span role="img" aria-label="cash" className="mr-1">🎁</span>{translations?.productValue}</span>
                    </div>}
                    <div className='flex flex-col'>
                        <span className='font-semibold'>{getApplicantRangeLabel(data?.applied)}</span>
                        <span className='font-medium text-xs'>{translations?.applicants}</span>
                    </div>
                </div>

                <div className="py-5 flex flex-col gap-4 border-b border-t border-lightGray my-6">
                    <div className="flex items-center justify-between">
                        <span className="text-sm">{translations?.influencerType}</span>
                        <span className="font-semibold">{Array.isArray(data?.influencer_type) ? data?.influencer_type.join(', ') : data?.influencer_type}</span>
                    </div>
                    <div className="flex items-center justify-between">
                        <span className="text-sm">{translations?.nicheCategory}</span>
                        <span className="font-semibold text-right ">{translateJobRequirements(data?.job_requirement, translations)}</span>
                    </div>
                    <div className="flex items-center justify-between">
                        <span className="text-sm">{translations?.location}</span>
                        <span className="font-semibold">{data?.campaign_country}</span>
                    </div>
                    {/* <div className="flex items-center justify-between">
                        <span className="text-sm">Audience Demographics</span>
                        <span className="font-semibold">{data?.audience_demographic}</span>
                    </div>
                    <div className="flex items-center justify-between">
                        <span className="text-sm">Gender</span>
                        <span className="font-semibold">{data?.gender_type}</span>
                    </div> */}
                </div>

                <div className="flex gap-5 justify-start">
                    {data?.platforms?.map(platform => availableIcons[platform])}
                </div>
            </div>
        </div>
    )
}

export default CampaignOverviewInfluencer
